import { useContext, useState } from "preact/hooks"
import { DayContext } from "../contexts/DayContext"
import { eventDays } from "../assets"

export default function DebugControllers(props) {
    const [position, setPosition] = useState("right")
    const {date, debug, disable, backup} = useContext(DayContext)
    const days = props.days || 1

    if (!debug) return <></>

    const style = {
        color: "black",
        borderRadius: "8px",
        padding: "5px 10px"
    }

    return <div style={{
        position: "fixed",
        top: 60,
        right: position === "right" ? 10 : "auto",
        left: position === "left" ? 10 : "auto",
        background: "rgba(0,0,0, 0.46)",
        borderRadius: 8,
        color: "white",
        lineHeight: 2,
        padding: 12,
        backdropFilter: "blur(6px)",
        zIndex: 1000,
        maxWidth: "400px"
    }}>
        <div style={{display: "flex", justifyContent: "space-between"}}>
            <h3 style={{lineHeight: 0.1, marginBottom: "10px"}}>Preview Tools</h3>
            <button style={style} onClick={disable}>Hide Tools</button>
        </div>
        <b>Tool Settings</b>
        <div>
            Position <button style={style} onClick={setPosition.bind(null, "left")}>left</button> <button style={style} onClick={setPosition.bind(null, "right")}>right</button>
        </div>
        <hr />
        <span>Event Day: <b>{date.day !== null ? eventDays[date.day].toISOString() : "Not Set"}</b></span>
        <div style={{display: "flex", gap: "8px"}}>
            {new Array(days).fill(null).map((_, idx) => <button style={style} onClick={() => date.setDay(idx)}>Day {idx + 1}</button>)}
            <button style={style} onClick={() => date.setDay(3)}>OD</button>
        </div>
        <button style={{width: "100%", marginTop: 8, ...style}} onClick={() => date.setDay(null)}>Clear selection</button>
        <hr />
        <button style={{width: "100%", marginTop: 8, ...style}} onClick={() => {
            const elements = document.getElementsByTagName("a")
            for (let e in elements) {
                elements[e].style.background = "rgba(0, 255, 0, 0.5)"
                elements[e].style.color = "white"
                elements[e].innerHTML = `LABEL = ${elements[e].getAttribute("data-event-label")} <br/> URL = ${elements[e].getAttribute("href")}`
            }
        }}>Highlight clickable areas</button>
        <hr />
        <button style={{width: "100%", marginTop: 8, ...style}} onClick={() => {
            Object.keys({...localStorage }).filter(it => it.startsWith("displayOnce")).map(it => localStorage.removeItem(it))
        }}>
            Clean Popups Cache
        </button>
        <span>* refresh is necessary</span>
        <hr />
        <span>Stream Status: { backup.using ? "Backup Stream" : "Regular Stream" }</span>
        <div style={{display: "flex", gap: "10px"}}>
            <button style={style} onClick={() => backup.setUsing(false)}>regular stream</button>
            <button style={style} onClick={() => backup.setUsing(true)}>backup stream</button>
        </div>
    </div>
}